var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettings24({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "[MGMT-02] \xEC\xA1\xB0\xEC\xA7\x81\xEA\xB4\x80\xEB\xA6\xAC > \xEC\x82\xAC\xEC\x9A\xA9\xEC\x9E\x90 \xEA\xB4\x80\xEB\xA6\xAC > \xEC\x82\xAC\xEC\x9A\xA9\xEC\x9E\x90 \xEA\xB4\x80\xEB\xA6\xAC(tab)",
    clipPath: "url(#clip0_138_41)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1358,
    height: 960,
    transform: "translate(-18 -84)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Light sidebar with constrained content area/Desktop",
    clipPath: "url(#clip1_138_41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Simple/Desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 869,
    transform: "translate(-18 -10)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sidebar Navigation/Expandable section"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar Navigation/Item"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 44,
    transform: "translate(-18 -10)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Officeware/Outline/user-group-corner"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3246 4.31731C10.751 2.5609 13.249 2.5609 13.6754 4.31731C13.9508 5.45193 15.2507 5.99038 16.2478 5.38285C17.7913 4.44239 19.5576 6.2087 18.6172 7.75218C18.0096 8.74925 18.5481 10.0492 19.6827 10.3246C21.4391 10.751 21.4391 13.249 19.6827 13.6754C18.5481 13.9508 18.0096 15.2507 18.6172 16.2478C19.5576 17.7913 17.7913 19.5576 16.2478 18.6172C15.2507 18.0096 13.9508 18.5481 13.6754 19.6827C13.249 21.4391 10.751 21.4391 10.3246 19.6827C10.0492 18.5481 8.74926 18.0096 7.75219 18.6172C6.2087 19.5576 4.44239 17.7913 5.38285 16.2478C5.99038 15.2507 5.45193 13.9508 4.31731 13.6754C2.5609 13.249 2.5609 10.751 4.31731 10.3246C5.45193 10.0492 5.99037 8.74926 5.38285 7.75218C4.44239 6.2087 6.2087 4.44239 7.75219 5.38285C8.74926 5.99037 10.0492 5.45193 10.3246 4.31731Z",
    stroke: "#4B5563",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
    stroke: "#4B5563",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1358,
    height: 960,
    fill: "white",
    transform: "translate(-18 -84)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_138_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1358,
    height: 895,
    fill: "white",
    transform: "translate(-18 -20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings24);
export default __webpack_public_path__ + "static/media/icon-settings-24.2fde6dd9975c67fbc96f194ba900e8a7.svg";
export { ForwardRef as ReactComponent };